// /settings/cash-rounding — Cash rounding (ops-simulation T07).
//
// The tenant default rule for cash payments: a step (precision) and a method
// (nearest / up / down). The POS rounds cash with it online and offline, the
// API recomputes it, and a sales invoice starts from it. A location can set
// its own rule (Locations › Settings). OWNER+ (50).

import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PageContainer, ErrorBoundary } from '@bbpos/ui';
import { useAuthStore } from '@/stores/use-auth-store';
import { useTenantCurrency } from '@/hooks/use-tenant-currency';
import { CashRoundingCard } from '@/components/features/settings/CashRoundingCard';

function CashRoundingContent() {
  const tenantId = useAuthStore((s) => s.profile?.tenant_id ?? '');
  const currency = useTenantCurrency();

  useEffect(() => { document.title = 'Cash Rounding — Settings — Orio360 Admin'; }, []);

  return (
    <PageContainer
      title="Cash Rounding"
      breadcrumbs={[
        { label: 'Home', href: '/home' },
        { label: 'Settings', href: '/settings' },
        { label: 'Cash Rounding' },
      ]}
    >
      <div className="animate-fade-in">
        <Link to="/settings" className="text-sm text-brand-600 dark:text-brand-400 hover:underline mb-4 inline-block">
          ← Back to Settings
        </Link>
        <div className="bg-gradient-to-r from-teal-600 via-brand-600 to-indigo-600 rounded-2xl p-6 text-white shadow-lg mb-6 relative overflow-hidden">
          <div className="pointer-events-none absolute -top-24 -right-24 h-56 w-56 rounded-full bg-white/10 blur-3xl" />
          <div className="relative">
            <h1 className="text-2xl font-bold text-white">Cash Rounding</h1>
            <p className="text-white/80 mt-1">How cash totals are rounded at the till and on sales invoices</p>
          </div>
        </div>
        <div className="max-w-2xl">
          <CashRoundingCard tenantId={tenantId} currency={currency} />
        </div>
      </div>
    </PageContainer>
  );
}

export function CashRoundingPage() {
  return (
    <ErrorBoundary>
      <CashRoundingContent />
    </ErrorBoundary>
  );
}
